import {DefaultDataServiceConfig} from "@ngrx/data";
import {environment} from "../../../environments/environment";

export const defaultDataServiceConfig: DefaultDataServiceConfig = {

    root:  environment.webserviceUrl + '/v1',
    timeout: environment.webservicesTimeOut, // request timeout,
    delete404OK: false,
};